export default __webpack_public_path__ + "static/media/EM1980.34I-43600_-26095_0.8e638b79.jpg";